// https://www.regular-expressions.info/unicode.html
// https://regexr.com/
// Email validation: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#Validation

export class ValidationPatterns {
  static validPasswordExpression = /^[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~]{8,20}$/;
  static validFirstNameExpression = /^[a-zA-Z\u00c0-\u017e\-.' ]+$/;
  static validInfixExpression = /^[a-zA-Z\- ]+$/;
  static validLastNameExpression = /^[a-zA-Z\u00c0-\u017e\-.' ]+$/;
  static validPhoneNumberExpression = /^\d+$/;
  static validDutchPhoneNumberExpression = /^0?6\d{8}$/;
  static validPostCodeExpression = /^\d+[a-zA-Z0-9\- ]*$/;
  static validHouseNumberExpression = /^[a-zA-Z0-9\- ]+$/;
  static validHouseNumberSubExpression = /^[a-zA-Z0-9\- ]+$/;
  static validEmailExpression = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
}
